import { initTranslatedItems, parseComplexObject } from '../utils/translationProcessor';

export const CONS = {
  title: 'Success',
  subHeader: 'You’ve connected your records to your account',
  continue: 'Continue'
};

// Translation configuration for success page
export const SUCCESS_TRANSLATION_CONFIG = [{ key: 'CONS', value: CONS, message: JSON.stringify(CONS) }];

// Helper function to process translated items
export const processSuccessTranslations = (translatedItems: any) => {
  translatedItems = initTranslatedItems(translatedItems);

  return {
    CONS: parseComplexObject(translatedItems, CONS)
  };
};
